
import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '@/contexts/auth/AuthContext';
import { menuItems } from '../AppSidebar';

interface DesktopSidebarProps {
  isOpen: boolean;
}

const DesktopSidebar: React.FC<DesktopSidebarProps> = ({ isOpen }) => {
  const location = useLocation();
  const { currentUser, isAdmin } = useAuth();

  if (!isOpen) return null;

  return (
    <div className="w-64 h-full">
      <div className="sticky top-0 flex h-screen flex-col bg-sidebar text-sidebar-foreground border-r border-sidebar-border">
        <div className="p-4 border-b border-sidebar-border">
          <Link to="/dashboard" className="flex items-center">
            <img 
              src="/lovable-uploads/924a6ca1-11fb-46d9-a66b-f6b94a0c23c6.png" 
              alt="ProptPilot Logo" 
              className="h-8 w-auto max-w-[120px] rounded bg-background px-1"
              style={{ objectFit: 'contain' }}
            />
          </Link>
        </div>
        <nav className="flex-1 overflow-y-auto p-3">
          <div className="space-y-1">
            {menuItems.map((item) => {
              const Icon = item.icon;
              const isActive = location.pathname === item.path;
              return (
                <Link
                  key={item.path}
                  to={item.path}
                  className={`relative flex items-center gap-3 rounded-lg px-3 py-2.5 text-sm transition-colors w-full ${
                    isActive 
                      ? 'bg-sidebar-primary text-sidebar-primary-foreground font-semibold shadow-card' 
                      : 'text-sidebar-foreground hover:bg-sidebar-accent hover:text-sidebar-accent-foreground font-medium'
                  }`}
                >
                  
                  <Icon className="h-5 w-5 flex-shrink-0" />
                  <span>{item.label}</span>
                </Link>
              );
            })}
            {isAdmin && (
              <Link
                to="/admin"
                className={`relative flex items-center gap-3 rounded-lg px-3 py-2.5 text-sm transition-colors w-full ${
                  location.pathname === '/admin'
                    ? 'bg-sidebar-primary text-sidebar-primary-foreground font-semibold shadow-card' 
                    : 'text-sidebar-foreground hover:bg-sidebar-accent hover:text-sidebar-accent-foreground font-medium'
                }`}
              >
                <span className="h-5 w-5 flex-shrink-0">🛡️</span>
                <span>Admin</span>
              </Link>
            )}
          </div>
        </nav>
        
        {/* Desktop user info at bottom */}
        {currentUser && (
          <div className="p-4 border-t border-sidebar-border mt-auto">
            <div className="text-sm text-sidebar-foreground">
              <div className="truncate max-w-[220px]">
                {currentUser.email}
              </div>
              {isAdmin && (
                <div className="text-warning text-xs mt-1">(Admin)</div>
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default DesktopSidebar;
